export default __webpack_public_path__ + "static/media/o3.cc0515da.webp";